import React, { useState, useContext, useEffect, useRef } from 'react';
import GoogleMapReact from 'google-map-react';
import { useQuery } from 'react-apollo';
import EventMarker from './EventMarker';
import { EventMapContext } from '../../context/EventMapContext';
import useWindowSize from '../../hooks/useWindowSize';
import useOutsideClick from '../../hooks/useOutsideClick';
import MobileActiveMarker from '../Map/MobileActiveMarker';
import { userQuery } from '../../constants/queries';
import { clientNoVarnish } from '../client';

const initialZoom = 11;

const EventsMapSection = ({ events, mapEventBounds }) => {
  const { data: userData } = useQuery(userQuery, {
    fetchPolicy: 'no-cache',
    client: clientNoVarnish,
  });

  const {
    setBounds,
    mapCenter,
    setCurrentPage,
    shouldFitBounds,
    setShouldFitBounds,
    setMapLoaded,
  } = useContext(EventMapContext);

  //   const [mapVisible, setMapVisible] = useState(false);
  const [activeMarker, setActiveMarker] = useState(null);

  const updateBounds = ({ bounds: newBounds }) => {
    setBounds(newBounds);
    setCurrentPage(1);
  };

  const { width } = useWindowSize();
  const isPhone = width <= 425;

  const [mobileCardsList, setMobileCardsList] = useState([]);
  useEffect(() => {
    if (activeMarker) {
      const activeMarkerData = events.find(
        record => record.id === activeMarker
      );

      const mobileCardsListArray = [];
      if (activeMarkerData) mobileCardsListArray.push(activeMarkerData);
      mobileCardsListArray.push(
        ...events.filter(item => item.id !== activeMarker || !item.id)
      );
      setMobileCardsList(mobileCardsListArray);
    } else {
      setMobileCardsList([]);
    }
  }, [activeMarker, events]);

  const markerWrapperRef = useRef(null);
  useOutsideClick(markerWrapperRef, true, () => {
    setActiveMarker(false);
  });

  const showMobileActiveMarker = isPhone && activeMarker;

  return (
    <div className="map-section events-map-section">
      <GoogleMapReact
        bootstrapURLKeys={{
          // @TODO: Add this to an environment variable or something
          key: 'AIzaSyATvnQePj9OTTCZJ6VkugYM8dRGFPJ5HmQ',
        }}
        defaultCenter={mapCenter}
        defaultZoom={initialZoom}
        onChange={updateBounds}
        onGoogleApiLoaded={({ map }) => {
          setMapLoaded(true);
          if (shouldFitBounds) map.fitBounds(mapEventBounds);
          setShouldFitBounds(false);
        }}
      >
        {events
          .filter(event => event.longitude && event.latitude)
          .map(event => (
            <EventMarker
              key={event.id}
              lat={event.latitude}
              lng={event.longitude}
              event={event}
              changeActiveMarker={setActiveMarker}
              activeMarker={activeMarker}
            />
          ))}
      </GoogleMapReact>

      {isPhone && (
        <section
          ref={markerWrapperRef}
          className="mobile-active-marker-container"
        >
          <div className="mobile-active-marker-overflow">
            {showMobileActiveMarker &&
              mobileCardsList.map(item => (
                <MobileActiveMarker
                  item={item}
                  itemType="events"
                  userData={userData}
                  changeActiveMarker={setActiveMarker}
                />
              ))}
          </div>
        </section>
      )}
    </div>
  );
};

export default EventsMapSection;
